<template>
  <div class="detail">
    <video-player
      :baseUrl="curData.baseUrl"
      :videoUrl="curData.videoUrl"
      :title="curData.title"
      :setNum="curData.setNum"
      :num="curData.num"
      :watermark="curData.license"
      :videoFormat="curData.videoFormat"
      :autoplay="true"
    ></video-player>

    <div class="content" style="clear: both; height: 700px">
      <evaluate-box></evaluate-box>

      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";
import EvaluateBox from "./EvaluateBox.vue";
import RankingBox from "./RankingBox.vue";
import commonData from "./commonData.js"
import videos from "../ossVideo2";

export default {
  name: "CommonDetail",
  components: { VideoPlayer, EvaluateBox, RankingBox },
  data() {
    return {
      pageData: commonData,
      curData: {},
      rankingList: videos.puzzleRankingList,
    };
  },
  watch: {
    $route: {
      handler() {
        const pageId = this.$route.query.id;
        this.curData = this.pageData[pageId];
      },
      deep: true,
    },
  },
  created() {
    const pageId = this.$route.query.id;
    this.curData = this.pageData[pageId] || this.pageData.bear;
  }
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
  }
}
</style>


